import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
} from 'components/core';

type Props = {
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
  isSaving?: boolean;
};

const SaveChangesModal = ({
  onSave,
  onDiscard,
  onCancel,
  isSaving = false,
}: Props): JSX.Element => {
  const [isOpen, setOpen] = useState(true);

  const cancel = () => {
    setOpen(false);
    onCancel();
  };

  return (
    <Modal isOpen={isOpen} onClose={cancel} aria-label="Save changes">
      <ModalHeader>Would you like to save changes?</ModalHeader>
      <ModalBody>
        <Text>
          You have unsaved changes to this extraction. If you continue without
          saving, changes will be lost.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button type="neutral" variant="outline" onClick={onDiscard}>
          No, continue
        </Button>
        <Button type="brand" isLoading={isSaving} onClick={onSave}>
          Yes, save and continue
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SaveChangesModal;
